import * as React from 'react';
import * as AwsUi from 'AWS-UI-Components-React';

import { TreeLineModes, treeLineStyle, showBottom, showRight, showTop } from './TreeLine';

interface ButtonWithTreeLinesProps {
  iconType: string;
  onClick?: () => void;
  mode: TreeLineModes;
  expand: string;
  level: number;
}

export const tableRowHeightInRem: number = 3;
export const iconButtonWidthInRem: number = 3;
export const iconButtonOffset: number = -4.5;
export const iconButtonIconLengthInRem: number = 1.4;
export const iconButtonMidpointX: number = iconButtonWidthInRem / 2;
export const iconButtonIconRightX: number = iconButtonMidpointX + iconButtonIconLengthInRem / 2;
export const iconButtonMidpointY: number = tableRowHeightInRem / 2;
export const iconButtonIconTopY: number = iconButtonMidpointY - iconButtonIconLengthInRem / 2;
export const iconButtonIconBottomY: number = iconButtonMidpointY + iconButtonIconLengthInRem / 2;
export const svgWidthInRem: number = iconButtonWidthInRem;

const iconMap = {
  expand: 'treeview-expand',
  collapse: 'treeview-collapse',
};

const ButtonWithTreeLines = ({
  iconType,
  onClick,
  mode,
  expand,
  level,
  isLoading = false,
}: ButtonWithTreeLinesProps) => {
  return (
    <div
      className="ui-util-mv-i-s"
      style={{
        left: iconButtonOffset + 2 * (level + 1) + `rem`,
        top: `-1rem`,
        height: `0rem`,
        position: 'relative',
      }}
    >
      <svg
        style={{
          position: 'absolute',
          top: expand !== 'top' ? `0.5rem` : `-1.7rem`,
          left: `1rem`,
          right: 0,
          bottom: 0,
          width: `${svgWidthInRem}rem`,
          height: `${tableRowHeightInRem}rem`,
        }}
        viewBox={`0 0 ${svgWidthInRem} ${tableRowHeightInRem}`}
      >
        {showTop(mode) && (
          <line
            x1={`${iconButtonMidpointX}`}
            y1="0"
            x2={`${iconButtonMidpointX}`}
            y2={`${iconButtonIconTopY}`}
            style={treeLineStyle}
          />
        )}
        {showBottom(mode) && (
          <line
            x1={`${iconButtonMidpointX}`}
            y1={`${tableRowHeightInRem}`}
            x2={`${iconButtonMidpointX}`}
            y2={`${iconButtonIconBottomY}`}
            style={treeLineStyle}
          />
        )}
        {showRight(mode) && (
          <line
            x1={`${iconButtonIconRightX}`}
            y1={`${iconButtonMidpointY}`}
            x2={`${svgWidthInRem}`}
            y2={`${iconButtonMidpointY}`}
            style={treeLineStyle}
          />
        )}
      </svg>

      <span style={{ marginLeft: `1rem` }} />
      <AwsUi.Button
        variant="icon"
        icon={iconMap[iconType]}
        onClick={onClick}
        className="awsui-util-mt-xs"
        loading={isLoading}
      />
    </div>
  );
};

export default ButtonWithTreeLines;



// WEBPACK FOOTER //
// ./src/components/content/table/ButtonWithTreeLines.jsx